import React from 'react';
import { FMessage, iFMessage } from '../../hoc/IntlComponents';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { startApproveContract } from '../../actions/contracts';

const ContractControls = (props) => {
  const {
    status,
    id,
    el,
    type: contractType,
    startApproveContract,
    handleEdit,
    showAlert,
    openRemoveModal,
    intl,
  } = props;
  const handleApproveContract = (contractType, data) => {
    startApproveContract(contractType, data).then(() => {
      showAlert({
        alertType: 'success',
        message: iFMessage({ intl, id: 'contracts.alert.approve.success' }),
        dismissable: true,
      });
    });
  };
  const getBtnsProps = () => {
    const btnProps = [
      {
        type: 'delete',
        method: () => openRemoveModal(contractType, id),
        color: 'danger',
      },
    ];
    if (status === 1) {
      btnProps.push(
        {
          type: 'edit',
          method: () => handleEdit(id, contractType),
          color: 'success',
        },
        {
          type: 'approve',
          method: () => handleApproveContract(contractType, { id, ...el }),
          color: 'info',
        },
      );
    }
    return btnProps;
  };
  const renderBtns = () => {
    const btns = getBtnsProps();
    return (
      btns &&
      btns.map(({ type, method, color }, index) => (
        <Button key={index} className="btn btn-md form-group-btn" color={color} onClick={method} outline>
          <FMessage id={`contracts.item.control.${type}`} />
        </Button>
      ))
    );
  };
  return <div className="contract-controls">{renderBtns()}</div>;
};

const mapDispatchToProps = (dispatch) => ({
  startApproveContract: (contractType, item) =>
    dispatch(startApproveContract(contractType.toLowerCase(), item)),
});

export default connect(null, mapDispatchToProps)(injectIntl(ContractControls));
